<template>

  <div class="main__wrapper">
    <div class="container-xxxl container-xxl container-xl container">
      <div class="col-xxl-4 col-xl-4 col-lg-6 col-md-8 offset-xxl-4 offset-xl-4 offset-lg-3 offset-md-2">
        <div class="sign__block">
          <router-link
              :to="{ name: 'Home' }"
              class="sign__logo"
          ><img src="@/assets/v2/img/logo_ru.svg" alt="Logo"></router-link>
          <div class="sign__form">
            <h3 class=""><strong>{{ $lang.app.AUTHENTICATION }}</strong></h3>
            <div
                v-if="$route.params.status === 'waiting-for-email-confirmation'"
                class="mb-6"
            >
              <p class="text-green-600 text-xl">
                {{ $lang.app.REGISTRATION_ACCESS_REGISTRATION_COMPLETED_SUCCESSFULLY }}!
              </p>
              <p class="text-red-600">
                {{ $lang.app.REGISTRATION_CONFIRM_EMAIL_TEXT }}
              </p>
            </div>
            <Form @submit="login" :validation-schema="schema">
              <div class="input__group">
                <label for="sign__email" class="label">{{ $lang.app.EMAIL }}</label>
                <Field
                    name="login"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="email"
                         id="sign__email"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER_EMAIL"
                         required>
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
              <div class="input__group">
                <label for="sign__password" class="label">{{ $lang.app.PASSWORD }}</label>
                <Field
                    name="password"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="password"
                         id="sign__password"
                         class="input"
                         :placeholder="$lang.app.ENTER_PASSWORD"
                         required
                         :class="{'input--fail': errorMessage }">
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
              <router-link
                  :to="{ name: 'ForgotPassword' }"
                  class="sign__link"
              >{{ $lang.app.FORGOT_PASSWORD }}</router-link>
              <button type="submit" class="relative button button--full"
                      :disabled="submitting">
                {{ $lang.app.TO_LOGIN }}
                <div v-if="submitting" class="loading-blue text-white absolute z-10 w-full rounded-lg h-full top-0 left-0 flex items-center justify-center">
                  <div class="block animate-spin">
                    <RefreshIcon class="w-6 h-6 mirror-y"/>
                  </div>
                </div>
              </button>
              <a :href="eKyzmatUrl" class="button button--full button--transparent">
                {{ $lang.app.LOGIN_AS_EMPLOYEE }}
              </a>
              <hr class="sign__hr">
              <router-link
                  :to="{ name: 'Register' }"
                  class="button button--full button--dark"
              >{{ $lang.app.NO_PROFILE_REGISTER }}</router-link>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import {Field, Form} from "vee-validate";
import * as yup from "yup";
import authApi from "@/api/auth";

export default {
  name: "Login",
  components: {
    Field,
    Form,
  },
  data() {
    return {
      submitting: false,
      schema: yup.object({
        login: yup.string().required(),
        password: yup.string().required(),
      }),
      eKyzmatUrl: null
    };
  },
  created() {
    this.getEkyzmatUrl();
  },
  methods: {
    login(values, actions) {
      this.submitting = true
      this.$store
          .dispatch("login", values)
          .then(() => {
            if(this.$store.getters.getAttemptUrl) {
              this.$router.push(this.$store.getters.getAttemptUrl)
              this.$store.commit('setAttemptUrl', null)
            } else {
              this.$router.push({
                name: 'ApplicantApplicationsList'
              });
            }
          })
          .catch((err) => {
            if (err.response.status === 422) {
              actions.setErrors(err.response.data.errors);
            }
          }).finally(() => {
            this.submitting = false
          })
    },

    getEkyzmatUrl() {
      authApi.getEKyzmatUrl()
          .then((data) => {
            let redirect_uri = window.location.origin + '/auth-ekyzmat';
            this.eKyzmatUrl = data.url + '&redirect_uri=' + redirect_uri;
          })
          .catch((error) => {
            console.log(error)
          });
    }
  },
};
</script>
